<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.correctionOrInterpretationOfJudgmentRequest.title">
      <v-row>
        <v-col cols="6">
          <naj-input
            :type-id="formFieldType.radioButton"
            :value.sync="formModel.FixType.Value"
            :value-name.sync="formModel.FixType.Text"
            :items="correctionOrInterpretationOfJudgmentRequestType"
            item-text="name"
            item-value="id"
            :label="local.caseRelatedRequest.correctionOrInterpretationOfJudgmentRequest.subRequestType"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.judgementCode"
            :label="local.caseRelatedRequest.correctionOrInterpretationOfJudgmentRequest.judgementCode"
            :items="judgments"
            item-value="judgementCode"
            item-text="judgementCode"
            validates="required"
            :disabled="isViewMode || isEditMode"
            @change="setSelectedJudgment"
          >
          </naj-input>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'CorrectionOrInterpretationOfJudgmentRequest',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      judgments: [],
      selectedJudgment: {},
    };
  },
  computed: {
    ...mapLUTState(['correctionOrInterpretationOfJudgmentRequestType']),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
  },
  watch: {},
  mounted() {
    if (this.formModel && this.formModel.judgementCode) {
      this.setSelectedJudgment();
    }

    this.$set(this.formModel, 'FixType', this.formModel.FixType ? this.formModel.FixType : {
      Text: '',
      Value: '',
    });

    if (this.formModel.FixType && this.formModel.FixType.Value) {
      this.formModel.FixType.Value = parseInt(this.formModel.FixType.Value);
    }

    this.readCurrentUserInfo();

    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    this.getCaseJudgments(params)
      .then((res) => {
        this.judgments = res.data;
        this.setSelectedJudgment();
      })
      .finally(() => (this.loading = false));
  },
  created() {
  },
  methods: {
    ...mapActions([
      'getCaseJudgments',
    ]),
    setSelectedJudgment() {
      this.formModel.judgementCode && this.$set(this, 'selectedJudgment', (this.judgments || []).find(a => a.judgementCode == this.formModel.judgementCode) || {});
    },
    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.judgement-deed {
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .attachment-item {
  cursor: pointer;
}
</style>